import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    title: '影视导航',
    links: [
      { label: '电影频道', to: '/category/movie' },
      { label: '电视剧频道', to: '/category/tv' },
      { label: '最新资讯', to: '/news' },
      { label: '影评攻略', to: '/special' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '关于御宅屋', to: '/about' },
      { label: '联系我们', to: '/about' },
      { label: '内容声明', to: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-950 border-t border-primary-800/60">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">御宅屋</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-md">
              御宅屋是一个专注于影视娱乐资讯聚合的内容平台，为你提供最新电影、电视剧资讯，以及丰富的影视推荐、影评与攻略。愿每一次打开，都能让你遇见一部好作品。
            </p>
            <div className="flex items-center gap-3 mt-5">
              {['ri-wechat-line', 'ri-weibo-line', 'ri-bilibili-line', 'ri-mail-line'].map((icon) => (
                <span
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-900/70 text-foreground-700 hover:text-accent-400 transition-colors cursor-pointer"
                >
                  <i className={icon}></i>
                </span>
              ))}
            </div>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-semibold text-foreground-900 mb-4">
                {col.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-600 hover:text-accent-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-primary-800/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            © 2026 御宅屋 · 本站内容均为演示数据，不提供真实播放与下载服务
          </p>
          <p className="text-xs text-foreground-600">影视资讯聚合平台 · 仅供学习交流</p>
        </div>
      </div>
    </footer>
  );
}